
export default  {
    name: "Intermodal Facilities",
    mapLayerIcon: "/mapicons/loadingzones/intermodal.png",
    defaultOn: false,
    showOnMap: true,
    publishLayer: "tasWebapp.cityboundaries.enable",
    geoJsonUrl: "static/Intermodal_Facilities.json",
    geoJsonPopups: true,
    geoOptions: {
        icon: "/mapicons/loadingzones/intermodal.png",
    }
}